import '../components/vueData/vueData.element';
import '../components/product-family/product-family.element';
import '../components/video-layer/video-layer.element';
import '../components/carousel/carousel';
import '../components/carousel/carousel-container';
import '../components/carousel/carousel-navi-next';
import '../components/carousel/carousel-navi-prev';
import '../components/tooltip/tooltip';
import '../components/anchor-link/anchor-link.element';
import '../components/modal/modal';
import { initMaskedLinks } from '../components/shop-link/shop-link';

initMaskedLinks(document.body);
